import { useCallback, useState } from 'react';

export const useForceRender = () => {
  const [, render] = useState({});
  // This function has to be wrapped with useCallback to force a render on each and every call.
  // Without the useCallback it may not always force the render.
  return useCallback(() => render({}), []);
};
